const faqs = [
  {
    q: '吃瓜黑料爆料的信息来源可靠吗？',
    a: '我们聚合来自多个渠道的娱乐资讯，包括公开报道、社交媒体线索和匿名投稿。所有信息均标注来源和可信度等级，对于未经证实的传闻会明确标注"待核实"。我们鼓励用户交叉验证，理性吃瓜。',
  },
  {
    q: '如何向平台投稿爆料？',
    a: '您可以通过顶部导航的"我要爆料"入口，或者直接发送邮件到我们的投稿邮箱。我们支持文字、图片、音频等多种格式，所有爆料人均享受匿名保护，您的个人信息绝不会被泄露。',
  },
  {
    q: '平台上的内容多久更新一次？',
    a: '我们采用 7×24 小时全天候追踪模式，编辑团队实时监控全网娱乐动态。重大突发事件 15 分钟内出快讯，深度解析文章通常在事件发生后 2-4 小时内完成。日均更新量超过 50 条。',
  },
  {
    q: '如何确保自己不会错过重要爆料？',
    a: '您可以下载吃瓜黑料爆料 APP 并开启推送通知，或者关注我们的社交媒体账号。APP 支持按话题、艺人、事件类型个性化订阅，确保第一时间收到您关心的内容。',
  },
  {
    q: '平台会删除或修改已发布的内容吗？',
    a: '对于已证实的错误信息，我们会及时更正并标注修改记录。但我们不会因外部压力删除真实报道。如果内容涉及法律纠纷，我们会按照相关法律法规和司法机关要求处理。',
  },
  {
    q: '如何在平台上找到特定艺人的所有相关爆料？',
    a: '您可以使用站内搜索功能，按艺人姓名、事件关键词或时间范围进行检索。每个艺人和事件都有专属的话题标签页，汇集了该主题下的所有相关内容，方便一站式浏览。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于吃瓜黑料爆料，你可能想了解的一些事情
          </p>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/70">
          {faqs.map((faq, i) => (
            <details key={i} className="group py-5 cursor-pointer">
              <summary className="flex items-center justify-between list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-primary-500">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed pl-0">
                {faq.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}